
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Fail fast in development if Supabase env vars are missing
if (import.meta.env.DEV && (!supabaseUrl || !supabaseAnonKey)) {
    throw new Error(
        'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. ' +
        'Copy .env.development.example to .env.local and fill in your Supabase credentials.'
    );
}

let guestSessionId: string | null = null;

export const setGuestSessionId = (id: string | null) => {
    guestSessionId = id;
};

export const supabase = createClient(
    supabaseUrl || 'https://placeholder.supabase.co',
    supabaseAnonKey || 'placeholder-key',
    {
        global: {
            fetch: (url, options) => {
                const headers = new Headers(options?.headers);
                if (guestSessionId) {
                    headers.set('x-guest-session-id', guestSessionId);
                }
                return fetch(url, { ...options, headers });
            },
        },
    }
);
